export { default as DashboardPage } from './Dashboard'
